// File: frontend/src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ScrollToTop from './components/utility/ScrollToTop';
import PageTransition from './components/utility/PageTransition';
import ErrorBoundary from './components/utility/ErrorBoundary';
import { LanguageProvider } from './contexts/LanguageContext';
import { SEOProvider } from './contexts/SEOContext';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { NotificationProvider } from './contexts/NotificationContext';
// import { PrivacyProvider } from './contexts/PrivacyContext';
// import ConsentWrapper from './components/PrivacyConsent/ConsentWrapper';
// import ScrollLockProvider from './components/utility/ScrollLockProvider';

// Import global styles for Cover Crush
import './styles/global/global.css';
import './styles/colors/colors.css';
import './styles/variables/variables.css';
import './styles/themes/default.css';

// Import layouts
import MainLayout from './components/layout/MainLayout/MainLayout';

// Import Cover Crush pages
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Compare from './pages/Compare/Compare';
import Analysis from './pages/Analysis/Analysis';
import Results from './pages/Results/Results';

// Import utility pages
import Privacy from './pages/Privacy/Privacy';
import Terms from './pages/Terms/Terms';
import NotFound from './pages/NotFound/NotFound';

// Optional: Legacy dashboard (if you want to keep it)
// import Dashboard from './pages/Dashboard/Dashboard';

const App = () => {
  return (
    <ErrorBoundary>
      <Router>
        <ScrollToTop />
        <SEOProvider>
          <AuthProvider>
            <LanguageProvider>
              {/* <PrivacyProvider> */}
                <ThemeProvider>
                  <NotificationProvider>
                    {/* <ScrollLockProvider> */}
                      {/* <ConsentWrapper> */}
                        <PageTransition>
                          <Routes>
                            {/* Main Cover Crush Pages */}
                            <Route 
                              path="/" 
                              element={
                                <MainLayout>
                                  <Home />
                                </MainLayout>
                              } 
                            />
                            
                            <Route 
                              path="/about" 
                              element={
                                <MainLayout>
                                  <About />
                                </MainLayout>
                              } 
                            />
                            
                            <Route 
                              path="/compare" 
                              element={
                                <MainLayout>
                                  <Compare />
                                </MainLayout>
                              } 
                            />
                            
                            {/* Analysis Flow - No MainLayout for full-screen experience */}
                            <Route 
                              path="/analysis" 
                              element={<Analysis />} 
                            />
                            
                            {/* Results Flow - No MainLayout for full-screen viral moment */}
                            <Route 
                              path="/results/:id" 
                              element={<Results />} 
                            />
                            
                            {/* Legal Pages */}
                            <Route 
                              path="/privacy" 
                              element={
                                <MainLayout>
                                  <Privacy />
                                </MainLayout>
                              } 
                            />
                            
                            <Route 
                              path="/terms" 
                              element={
                                <MainLayout>
                                  <Terms />
                                </MainLayout>
                              } 
                            />
                            
                            {/* Support Pages */}
                            <Route 
                              path="/help" 
                              element={
                                <MainLayout>
                                  <div style={{ padding: '4rem 2rem', textAlign: 'center' }}>
                                    <h1>Help Center</h1>
                                    <p>Coming soon! For now, contact us at support@covercrush.com</p>
                                  </div>
                                </MainLayout>
                              } 
                            />
                            
                            <Route 
                              path="/contact" 
                              element={
                                <MainLayout>
                                  <div style={{ padding: '4rem 2rem', textAlign: 'center' }}>
                                    <h1>Contact Us</h1>
                                    <p>Email us at hello@covercrush.com</p>
                                  </div>
                                </MainLayout>
                              } 
                            />
                            
                            <Route 
                              path="/security" 
                              element={
                                <MainLayout>
                                  <div style={{ padding: '4rem 2rem', textAlign: 'center' }}>
                                    <h1>Security</h1>
                                    <p>Your data is protected with bank-level encryption.</p>
                                  </div>
                                </MainLayout>
                              } 
                            />
                            
                            <Route 
                              path="/feedback" 
                              element={
                                <MainLayout>
                                  <div style={{ padding: '4rem 2rem', textAlign: 'center' }}>
                                    <h1>Feedback</h1>
                                    <p>We'd love to hear from you! Email feedback@covercrush.com</p>
                                  </div>
                                </MainLayout>
                              } 
                            />
                            
                            <Route 
                              path="/examples" 
                              element={
                                <MainLayout>
                                  <div style={{ padding: '4rem 2rem', textAlign: 'center' }}>
                                    <h1>Examples</h1>
                                    <p>See real examples on our Compare page!</p>
                                  </div>
                                </MainLayout>
                              } 
                            />

                            {/* Legacy Dashboard (optional - uncomment if needed) */}
                            {/* 
                            <Route 
                              path="/dashboard" 
                              element={
                                <MainLayout>
                                  <Dashboard />
                                </MainLayout>
                              } 
                            />
                            */}

                            {/* Catch-all 404 route */}
                            <Route 
                              path="*" 
                              element={
                                <MainLayout>
                                  <NotFound />
                                </MainLayout>
                              } 
                            />
                          </Routes>
                        </PageTransition>
                      {/* </ConsentWrapper> */}
                    {/* </ScrollLockProvider> */}
                  </NotificationProvider>
                </ThemeProvider>
              {/* </PrivacyProvider> */}
            </LanguageProvider>
          </AuthProvider>
        </SEOProvider>
      </Router>
    </ErrorBoundary>
  );
};

export default App;